import { Node, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';

import { useState, useEffect, useRef } from 'react';
import { getAllProductCategory } from '../../../../../api/productCategoriesApi';

const CategoryView = (props) => {
    const { editor } = props;

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null)

     useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await getAllProductCategory();                
                setCategories(response?.data?.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    const handleCategorySelect = (category) => {
        setSelectedCategories(prev => {
            const isSelected = prev.some(cat => cat.categoryId === category.categoryId);
            if (isSelected) {
                return prev.filter(cat => cat.categoryId !== category.categoryId);
            } else {
                return [...prev, category];
            }
        });
    };

    const handleInsert = () => {
        if (selectedCategories.length > 0) {
            const categoriesWithDefaults = selectedCategories.map(cat => ({
                ...cat,
            }));
            editor.chain().focus().setCategoryBlock({
                categories: categoriesWithDefaults,
            }).run();
        }
    };

    return (
        <NodeViewWrapper data-type='category'>
            <div className='category-selector-wrapper'>
                <h3>Select Categories</h3>
                <div className='category-selector'>
                    {loading ? (
                        <div>Loading categories...</div>
                    ) : (
                        <div className=''>
                            <div className="dropdown-wrapper"  ref={dropdownRef}>
                                <div className="dropdown-header" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                    <span className="title">Select Categories ({selectedCategories.length})</span>
                                </div>
                                {isDropdownOpen && (
                                    <div className="dropdown-list">
                                        {categories?.map(category => (
                                            <label key={category.categoryId} className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedCategories.some(c => c.categoryId === category.categoryId)}
                                                    onChange={() => handleCategorySelect(category)}
                                                />
                                                {category?.name}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <button className='save-btn' onClick={handleInsert} disabled={selectedCategories.length === 0}>
                        Insert Category Block
                    </button>
                </div>
            </div>
        </NodeViewWrapper >
    );
};

export const Category = Node.create({
    name: 'category',

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {
            categories: {
                default: [],
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            { 'data-type': this.name, class: 'category-block' },
            'Category Selector'
        ];
    },

    addCommands() {
        return {
            setCategory:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {
                                categories: options?.categories || [],
                            },
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(CategoryView);
    },
});